<template>
  <div class="path-history">
    <div 
      v-for="(item, index) in historyList" 
      :key="index" 
      class="path-item"
      :class="{ 'current-path': isCurrentPath(item.path) }"
    >
      <router-link 
        :to="item.path" 
        class="path-link"
        @click.native="scrollToTop"
      >
        {{ item.name }}
      </router-link>
      <el-button 
        v-if="!isCurrentPath(item.path)"
        class="remove-btn" 
        @click="removePath(index)"
        icon="el-icon-close"
      >
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['historyList']),
    currentPath() {
      return this.$route.fullPath
    }
  },
  methods: {
    isCurrentPath(path) {
      return path === this.currentPath
    },
    removePath(index) {
      this.$store.commit('REMOVE_PATH', index)
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

.path-history {
  display: flex;
  overflow-x: auto;
  padding-left: 24px;
  /* gap: 10px; */
}

.path-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
}

.current-path .path-link {
  color: #2962ff; 
}

.current-path{
  background: #F2F6FF;
  border-bottom: 2px solid #2962ff;
}

.path-link {
  text-decoration: none;
  color: #2c3e50;
  margin-right: 8px;
}

.path-link:hover {
  color: #2962ff;
}

.remove-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
  padding: 2px;
}

.remove-btn:hover {
  color: #e74c3c;
}
</style>